import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { finalize, catchError, throwError } from 'rxjs';
import { LoaderService } from './shared/services/loader.service';
import { Router } from '@angular/router';
import { ToastService } from './shared/services/toast.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const loaderService = inject(LoaderService);
  const router = inject(Router);  
  const toast = inject(ToastService)
  const token = localStorage.getItem('token') || '';
  const routePath = window.location.pathname;

  // 🔹 NEW — skip loader header check
  const skipLoader = req.headers.has('X-Skip-Loader');

  // 🔹 Remove skip header before sending to backend
  if (skipLoader) {
    req = req.clone({
      headers: req.headers.delete('X-Skip-Loader')
    });
  }

  const url = new URL(req.urlWithParams, window.location.origin);
  const viewType = url.searchParams.get('view_Type');

  const isDashboardRequest = req.url.includes('/DashboardInnerBoxData');
  const isDashboardRequestCWOrecharge = req.url.includes('/GetConsumptionWORecharge');
  const isSilentView = viewType === 's';
  const isLoginRequest = req.url.includes('/auth/login');
  const isConsumerDetail = req.url.includes('/ConsumerSearch');
  const isRechargeSummary = req.url.includes('/RechargeSummaryReport');

  const urlPath = router.url.split('?')[0];
  const isSiteSummaryRoute = urlPath.endsWith('/site_summary');

  // 🔹 MERGED LOGIC
  const shouldShowLoader =
    !skipLoader && // <-- NEW condition added
    (!isDashboardRequest || !isSiteSummaryRoute || !isDashboardRequestCWOrecharge) &&
    !isSilentView &&
    !isLoginRequest &&
    !isConsumerDetail &&
    !isRechargeSummary;

  if (shouldShowLoader) {
    loaderService.show();
  }

  // 🔹 Attach headers
  if (token) {
    req = req.clone({
      setHeaders: {
        Authorization: token,
        'X-Activated-Route': routePath
      }
    });
  }

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      const err = error.error;

      if (error.status === 401) {
        toast.showToast('Login Timeout', 'colored', 5000, 'danger');
        localStorage.removeItem('token');
        localStorage.removeItem('siteList');
        localStorage.removeItem('calculatedExpiry');
        sessionStorage.removeItem('calculatedExpiry');
        localStorage.removeItem('loginTimestamp');
        localStorage.removeItem('sidebarItems');
        localStorage.removeItem('sideMenuList');
        router.navigate(['/auth/login']);
      }

      return throwError(() => error);
    }),
    finalize(() => {
      if (shouldShowLoader) {
        loaderService.hide();
      }
    })
  );
};
